module.exports = __webpack_public_path__ + "media/images/emoticons/train-dd126835c51721f9a8429d5d07df9357.gif";